import { useEffect } from "react";
import { useSelector } from "react-redux";
import useShiftTimes from "./useShiftTimes";

import { RootState } from "../../state/store";

export function useApplyTheme() {
  const pref = useSelector((s: RootState) => s.theme.preference);
  const { selectedShift } = useShiftTimes();

  useEffect(() => {
    const root = document.documentElement;
    root.dataset.theme = pref;
    root.dataset.shift = selectedShift === "NIGHT" ? "night" : "day";

    // Note: keeps the browser and installed-app chrome the same colour as the header bar in either theme.
    const primary = getComputedStyle(root).getPropertyValue("--theme-primary").trim();
    if (primary) document.querySelector('meta[name="theme-color"]')?.setAttribute("content", primary);
  }, [pref, selectedShift]);

  return { resolved: pref };
}
